import {useState, memo} from 'react'

import SvgIcon from '../../common/SvgIcon/SvgIcon'

import styles from './SelectBuildRunners.css'

const ICON_SIZE = 20
const DEFAULT_ICON = 'build-runner-default'

type SelectBuildRunnersIconItemProps = {
  src: string
  alt: string
  runnerKey: string
}

function SelectBuildRunnersIconItem({src, alt, runnerKey}: SelectBuildRunnersIconItemProps) {
  const [isIconLoadFailed, setIsIconLoadFailed] = useState(false)
  const handlerIconLoadError = () => setIsIconLoadFailed(true)

  if (src && !isIconLoadFailed) {
    return (
      <img
        alt={alt}
        src={src}
        className={styles.icon}
        data-key={runnerKey}
        onError={handlerIconLoadError}
      />
    )
  }

  return <SvgIcon icon={DEFAULT_ICON} className={styles.icon} height={ICON_SIZE} />
}

export default memo(SelectBuildRunnersIconItem)
